import { useQuery } from '@tanstack/react-query'
import type { ISpClaimedReward } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'

const PROCESSING_REFETCH_MS = 10_000

export function useSpClaimedRewards(page = 1, pageSize = 20) {
  return useQuery({
    queryKey: queryKeys.spRewards.claimed(page, pageSize),
    queryFn: async () => {
      const { data } = await apiClient.get<ApiResponse<ISpClaimedReward[]>>(
        '/api/v1/sp/rewards/claimed',
        { params: { page, pageSize } },
      )
      return { items: data.data, meta: data.meta }
    },
    refetchInterval: (query) => {
      const items = query.state.data?.items ?? []
      return items.some((reward) => reward.status === 'processing')
        ? PROCESSING_REFETCH_MS
        : false
    },
  })
}
